import React, { Component } from 'react'
import Slider from 'react-slick'

class Carousel extends Component {
    renderSlider() {
        const settings = {
            dots: false,
            dragable: true,
            infinite: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1
        }

        const slideStyle = {
            height: 600,
            backgroundReapeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            // eslint-disable-next-line
            display: '-webkit-box',
            // eslint-disable-next-line
            display: '-moz-box',
            // eslint-disable-next-line
            display: '-ms-flexbox',
            // eslint-disable-next-line
            display: '-webkit-flex',
            // eslint-disable-next-line
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }

        const slideContent = {
            padding: '20px 80px',
            textAlign: 'center'
        }

        const contentP = {
            fontSize: '1.4em',
            margin: 0
        }

        return (
            <Slider {...settings} style={{ zIndex: 10 }}>
                {
                    this.props.slides.map((slide, key) => {
                        return (
                            <div key={key} style={{
                                ...slideStyle, backgroundImage: `url(${slide.image})`
                            }}>
                                <div style={{ ...slideContent }} className="slider-content">
                                    <h1 className="slider-title">{slide.title}</h1>
                                    <p style={{ ...contentP }} className="slider-text" dangerouslySetInnerHTML={{ __html: slide.text }}></p>
                                </div>
                            </div>
                        )
                    })
                }
            </Slider>
        )
    }

    render() {
        return (
            <div className={this.props.css}>
                {this.props.slides && this.renderSlider()}
            </div>
        )
    }
}

export { Carousel }


// WEBPACK FOOTER //
// ./src/components/sections/Carousel.js